export const MOUNT_SELECTOR = '.club-desktop-modal-info-mount'
export const DATA_PDF_COUPON = 'data-club-modal-info-coupon-pdf'
export const DATA_PDF_PARTICIPATION = 'data-club-modal-info-participation-pdf'
